var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getData as getDataAction } from '../../actions/unsettled-bets/creators/unsettledBets';
import { FormattedMessage, defineMessages } from 'react-intl';
import * as BetType from '../../constants/BetType';
import Single from '../betting-history/Single';
import Complex from '../betting-history/Complex';
import { Helmet } from 'react-helmet';
var messages = defineMessages({
    page_title: {
        id: 'briefcase_title',
        defaultMessage: 'Портфель ставок'
    },
    refresh_btn: {
        id: 'briefcase_refresh',
        defaultMessage: 'Обновить портфель'
    },
    balance: {
        id: 'briefcase_balance',
        defaultMessage: 'Баланс'
    },
    unsettled_bets: {
        id: 'briefcase_unsettled_bets',
        defaultMessage: 'В ставках'
    },
    claimed_for_withdrawal: {
        id: 'briefcase_claimed_for_withdrawal',
        defaultMessage: 'Заявлено на снятие'
    },
    available: {
        id: 'briefcase_available',
        defaultMessage: 'Доступно'
    },
});
var UnsettledBets = /** @class */ (function (_super) {
    __extends(UnsettledBets, _super);
    function UnsettledBets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSubmit = function () {
            _this.props.getDataAction(_this.props.languageId);
        };
        return _this;
    }
    UnsettledBets.prototype.componentDidMount = function () {
        this.props.getDataAction(this.props.languageId);
    };
    UnsettledBets.prototype.render = function () {
        var _this = this;
        var _a = this.props, unsettledBets = _a.unsettledBets, languageId = _a.languageId;
        var data = unsettledBets.data;
        var details = unsettledBets.details;
        var balance = data.Balance;
        var bets = data.InStakes;
        var withdrawal = data.InWithdrawal;
        var available = data.Available;
        var items = [];
        details.map(function (item, i) {
            switch (item.StakeType) {
                case BetType.SINGLE:
                    items.push(_jsx(Single, { betsDataItem: item, languageId: languageId }, i));
                    break;
                case BetType.EXPRESS:
                case BetType.ANTIEXPRESS:
                case BetType.SYSTEM:
                    items.push(_jsx(Complex, { betsDataItem: item, languageId: languageId }, i));
            }
        });
        var withdrawalMsg = withdrawal ? withdrawal.toFixed(2) : '';
        return (_jsxs("div", __assign({ id: 'content' }, { children: [_jsx(Helmet, { children: _jsxs("title", { children: [window.COMPANY_NAME, " \u2014 \u041F\u043E\u0440\u0442\u0444\u0435\u043B\u044C \u0441\u0442\u0430\u0432\u043E\u043A"] }) }), _jsxs("div", __assign({ className: 'backward' }, { children: [_jsx("a", { onClick: function () { return _this.props.history.goBack(); }, className: 'ajax back' }), _jsx("div", __assign({ className: 'header' }, { children: _jsx("div", __assign({ className: 'title' }, { children: _jsx(FormattedMessage, __assign({}, messages.page_title)) })) }))] })), _jsx("div", __assign({ className: 'block blc_briefcase' }, { children: _jsxs("ul", { children: [_jsxs("li", { children: [_jsx(FormattedMessage, __assign({}, messages.balance)), _jsx("strong", { children: balance })] }), _jsxs("li", { children: [_jsx(FormattedMessage, __assign({}, messages.unsettled_bets)), _jsx("strong", { children: bets })] }), _jsxs("li", { children: [_jsx(FormattedMessage, __assign({}, messages.claimed_for_withdrawal)), _jsx("strong", { children: withdrawalMsg })] }), _jsxs("li", { children: [_jsx(FormattedMessage, __assign({}, messages.available)), _jsx("strong", { children: available })] })] }) })), _jsx("div", __assign({ className: 'block blc_history blc_info history' }, { children: _jsx("div", __assign({ className: 'items' }, { children: items })) }))] })));
    };
    return UnsettledBets;
}(React.Component));
UnsettledBets.propTypes = {
    getDataAction: PropTypes.func.isRequired,
    unsettledBets: PropTypes.any.isRequired,
    languageId: PropTypes.any.isRequired
};
var mapToState = function (state) { return ({
    unsettledBets: state.application.get('unsettledBets'),
    languageId: state.application.get('languageId')
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    getDataAction: getDataAction
}, dispatch); };
export default withRouter(connect(mapToState, mapDispatchToProps)(UnsettledBets));



// WEBPACK FOOTER //
// ./src/components/unsettled-bets/Index.jsx